// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"274":"Home","561":"Dashboard"}[chunkId] || chunkId) + "." + {"6":"da1dbd88","101":"5a1f2759","124":"f985751e","130":"a7c0f357","274":"a17192c5","359":"a3e679c9","561":"5dea0a8e","600":"34f4c49d","623":"5a76a6b5","660":"b6970139"}[chunkId] + ".chunk.css";
};